module.exports = __webpack_public_path__ + "img/logo.d2512014.png";